import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useIntl, FormattedMessage } from 'react-intl'
import Price from 'components/shared/Price'
import SeparatedList from 'components/shared/SeparatedList'
import { useAppSelector } from 'store/hooks'
import { useResolutions } from 'store/resolutions'
import { SummaryItem } from 'components/global/Summary/components/SummaryItem'
import steps from 'index'
import { useApp } from 'store/steps'
import SummaryShipmentOption from 'components/global/Summary/sections/SummaryShipmentOption'
import { VoucherWithDetails } from 'store/api-slice/types'
import { SummaryGiftCardsList } from './Summary/sections/SummaryGiftCardsList'

// TODO: unify with desktop summary
const VouchersMobileSummary = () => {
    const { items, cart } = useAppSelector((state) => state.cart)
    const { stepIndex } = useApp()
    const { isTablet } = useResolutions()
    const { formatMessage } = useIntl()

    const {
        totalPrice: cartTotalPrice,
        beforeDiscountPrice,
        payByCardPrice,
    } = cart || {}

    const { vouchers, shipping } = items

    const isVouchersOrderStep = steps[stepIndex].id === 'vouchers_order'
    const shippingCost = shipping?.totalPrice

    const orderSumPrice = (cartTotalPrice ?? 0) - (payByCardPrice ?? 0)

    const grouppedVouchers: VoucherWithDetails[] = []
    vouchers.forEach((voucher) => {
        const matchedVoucherIndex = grouppedVouchers.findIndex(
            (grouppedVoucher) =>
                voucher.detail.amount
                    ? voucher.detail.amount === grouppedVoucher.detail.amount
                    : voucher.productId === grouppedVoucher.productId
        )

        if (
            matchedVoucherIndex !== -1 &&
            grouppedVouchers[matchedVoucherIndex] &&
            grouppedVouchers[matchedVoucherIndex].quantity
        ) {
            grouppedVouchers[matchedVoucherIndex] = {
                ...grouppedVouchers[matchedVoucherIndex],
                quantity:
                    (grouppedVouchers[matchedVoucherIndex].quantity || 0) + 1,
            }
        } else {
            grouppedVouchers.push(voucher)
        }
    })

    return (
        <>
            <Box direction="row" justify="space-between" mb={16}>
                <Text variant="heading5" color="secondary_500">
                    Voucher
                </Text>
            </Box>

            <SeparatedList gap={12} direction="column">
                {grouppedVouchers.map((voucher, index) => {
                    const {
                        unitPrice,
                        cartItemId,
                        totalPrice,
                        totalPriceWithoutDiscount,
                        hasPromotion,
                        quantity,
                        name,
                        description,
                        itemsBundle,
                    } = voucher

                    const isBundledVoucher = !!itemsBundle
                    const calculatedName =
                        isBundledVoucher && name
                            ? name
                            : formatMessage({
                                  id: 'vouchers.cart.value_item_label',
                                  defaultMessage: 'Kwota',
                              })
                    const calculatedDescription =
                        isBundledVoucher && description ? description : ''

                    return (
                        <SummaryItem
                            key={`${cartItemId}${index}`}
                            name={calculatedName}
                            quantity={quantity || 1}
                            description={calculatedDescription}
                            price={unitPrice || 0}
                            totalPrice={totalPrice || 0}
                            totalPriceWithoutDiscount={
                                totalPriceWithoutDiscount || 0
                            }
                            hasPromotion={hasPromotion}
                        />
                    )
                })}
            </SeparatedList>
            <SummaryGiftCardsList />

            <SeparatedList gap={16} direction="column">
                {isVouchersOrderStep && (
                    <Box isFullWidth>
                        <Box
                            isFullWidth
                            direction="row"
                            justify="space-between"
                            mt={32}
                            mb={18}
                        >
                            <Text variant="heading5" color="secondary_500">
                                {formatMessage({
                                    id: 'global.summary.section_caption_shipment_method',
                                    defaultMessage: 'Sposób dostawy',
                                })}
                            </Text>
                        </Box>

                        <SummaryShipmentOption
                            shippingCost={shippingCost}
                            freeShippingType="email"
                        />
                    </Box>
                )}

                <Box isFullWidth mt={isVouchersOrderStep ? 0 : 32}>
                    <Box
                        isFullWidth
                        direction="row"
                        justify="space-between"
                        mb={4}
                    >
                        <Box isFullWidth align="stretch" gap={8}>
                            <Box
                                direction="row"
                                align="flex-end"
                                justify="space-between"
                            >
                                <Text
                                    variant={isTablet ? 'body' : 'bodySmall'}
                                    color="secondary_500"
                                    mb={4}
                                >
                                    <FormattedMessage
                                        id="global.price.label_total_summary"
                                        defaultMessage="Do zapłaty"
                                    />
                                    :
                                </Text>
                                <Box align="flex-end">
                                    {!!beforeDiscountPrice &&
                                        beforeDiscountPrice > 0 && (
                                            <Price
                                                value={beforeDiscountPrice || 0}
                                                size="body"
                                                color="grayscale_700"
                                                crossedOutVariant="gray"
                                            />
                                        )}
                                    <Price
                                        value={orderSumPrice || 0}
                                        size="heading2"
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </SeparatedList>
        </>
    )
}

export default VouchersMobileSummary
